import axios from "axios"
import { getApiConfig, getAuthToken } from "../authHelper"

import { get, post, put, del } from "../api_helper"
import * as url from "../url_helper"
import { API_URL } from "../url_helper"

export const getAllSubscription = paymentStatus => {
  if (paymentStatus !== "all" && paymentStatus) {
    return get(
      `${url.SUBSCRIPTION}/all?paymentStatus=${paymentStatus}&sortBy=createdAt&sortOrder=-1`,
      getApiConfig()
    )
  }
  return get(`${url.SUBSCRIPTION}/all?sortBy=createdAt&sortOrder=-1`, getApiConfig())
}

export const getSubscription = id => {
  return get(`${url.SUBSCRIPTION}?_id=${id}`, getApiConfig())
}

export const getReport = (startDate, endDate) => {
  if (startDate && endDate) {
    return get(
      `${url.USER}/admin/reports?startDate=${startDate}&endDate=${endDate} `,
      getApiConfig()
    )
  }
  return get(`${url.USER}/admin/reports`, getApiConfig())
}

export const createSubscription = data => {
  return post(`${url.SUBSCRIPTION}`, data, getApiConfig())
}

export const updateSubscription = (id, data) => {
  return put(`${url.SUBSCRIPTION}/${id}`, data, getApiConfig())
}

// mark as paid
export const markAsPaidSubscription = id => {
  return put(`${url.SUBSCRIPTION}/mark-as-paid/${id}`, {}, getApiConfig())
}

export const deleteSubscription = id => {
  return del(`${url.SUBSCRIPTION}/${id}`, getApiConfig())
}

export const createSubscriptionV2 = data => {
  return post(`${url.SUBSCRIPTION_V2}`, data, getApiConfig())
}

export const sendInvoiceWhatsApp = paymentId => {
  return post(`${url.SUBSCRIPTION_V2}/invoices/${paymentId}/send`, {}, getApiConfig())
}

export const regenerateSubscriptionInvoice = paymentId => {
  return post(`${url.SUBSCRIPTION_V2}/invoices/${paymentId}/regenerate`, {}, getApiConfig())
}

export const getAllSubscriptionV2 = queryData => {
  const { page, limit, search, filterValue, startDate, endDate } = queryData
  const queryParams = new URLSearchParams();

  queryParams.append("sortOrder", "-1");
  if (search) queryParams.append("search", search);
  if (page && limit) {
    queryParams.append("page", page);
    queryParams.append("limit", limit);
  }
  if (startDate && endDate) {
    queryParams.append("startDate", startDate);
    queryParams.append("endDate", endDate);
  }
  if (filterValue === "expired") {
    queryParams.append("isExpired", "true");
  } else if (filterValue === "cancelled") {
    queryParams.append("invoiceStatus", "cancelled");
  } else if (filterValue !== "all") {
    queryParams.append("paymentStatus", filterValue);
  }
  return get(`${url.SUBSCRIPTION_V2}/all?${queryParams.toString()}`, getApiConfig());
}

export const markAsPaidSubscriptionV2 = id => {
  return put(`${url.SUBSCRIPTION_V2}/mark-as-paid/${id}`, {}, getApiConfig())
}

export const deleteSubscriptionV2 = id => {
  return del(`${url.SUBSCRIPTION_V2}/${id}`, getApiConfig())
}

export const updateSubscriptionV2 = (id, data) => {
  return put(`${url.SUBSCRIPTION_V2}/${id}`, data, getApiConfig())
}

export const cancelSubscriptionV2 = (id, data) => {
  return post(`${url.SUBSCRIPTION_V2}/${id}/cancel`, data, getApiConfig())
}

export const getSubscriptionCreditNotes = queryData => {
  const { page, limit, search, startDate, endDate } = queryData || {}
  const queryParams = new URLSearchParams()

  if (page && limit) {
    queryParams.append("page", page)
    queryParams.append("limit", limit)
  }
  if (search) queryParams.append("search", search)
  if (startDate && endDate) {
    queryParams.append("startDate", startDate)
    queryParams.append("endDate", endDate)
  }

  return get(`${url.SUBSCRIPTION_V2}/credit-notes?${queryParams.toString()}`, getApiConfig())
}

export const getManagedAddons = queryData => {
  const queryParams = new URLSearchParams()
  Object.entries(queryData || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      queryParams.append(key, value)
    }
  })
  return get(`${url.SUBSCRIPTION_V2}/addons/manage?${queryParams.toString()}`, getApiConfig())
}

export const cancelManagedAddon = data => {
  return post(`${url.SUBSCRIPTION_V2}/addons/manage/cancel`, data, getApiConfig())
}

export const getSubscriptionInfoV2 = (planId, query = {}) => {
  const queryParams = new URLSearchParams()
  if (query.userId) queryParams.append("userId", query.userId)
  if (query.editingSubscriptionId) queryParams.append("editingSubscriptionId", query.editingSubscriptionId)
  return get(`${url.SUBSCRIPTION_V2}/info/${planId}?${queryParams.toString()}`, getApiConfig())
}

export const getAddonCatalog = () => {
  return get(`${url.SUBSCRIPTION_V2}/addons/catalog?includeInactive=true`, getApiConfig())
}

export const getUserAddons = (userId, firmId) => {
  const query = firmId ? `?firmId=${firmId}` : ""
  return get(`${url.SUBSCRIPTION_V2}/addons/user/${userId}${query}`, getApiConfig())
}

export const createAddonPurchase = data => {
  return post(`${url.SUBSCRIPTION_V2}/addons/purchase`, data, getApiConfig())
}

export const updateAddonCatalog = (addonId, data) => {
  return put(`${url.SUBSCRIPTION_V2}/addons/catalog/${addonId}`, data, getApiConfig())
}

export const grantWhatsappTrial = userId => {
  return post(`${url.SUBSCRIPTION_V2}/addons/whatsapp/trial/${userId}`, {}, getApiConfig())
}

export const grantJobManagementTrial = (userId, trialDays) => {
  return post(`${url.SUBSCRIPTION_V2}/addons/job-management/trial/${userId}`, { trialDays }, getApiConfig())
}

export const downloadWhatsappTrialReport = async () => {
  const config = getApiConfig()
  const response = await axios.get(
    `${API_URL}${url.SUBSCRIPTION_V2}/addons/whatsapp/trial-report`,
    {
      ...config,
      responseType: "blob"
    }
  )

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement("a")
  link.href = blobUrl
  const dateStr = new Date().toISOString().split("T")[0]
  link.setAttribute("download", `whatsapp_trial_report_${dateStr}.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(blobUrl)
}

export const downloadJobManagementTrialReport = async () => {
  const config = getApiConfig()
  const response = await axios.get(
    `${API_URL}${url.SUBSCRIPTION_V2}/addons/job-management/trial-report`,
    {
      ...config,
      responseType: "blob"
    }
  )

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement("a")
  link.href = blobUrl
  const dateStr = new Date().toISOString().split("T")[0]
  link.setAttribute("download", `job_management_trial_report_${dateStr}.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(blobUrl)
}
